'use strict';

const React = require('react');
const components_display_Badge_Badge = require('../../display/Badge/Badge.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

function PageNavigationBadge(props) {
  return React__default.default.createElement(
    "span",
    { "data-zds": true },
    React__default.default.createElement(components_display_Badge_Badge.Badge, Object.assign({}, props))
  );
}

module.exports = PageNavigationBadge;
//# sourceMappingURL=PageNavigationBadge.cjs.js.map
